import { str } from "16";

export function formatToIndianRupees(num) {
  // Convert the number to a string
  if (num === null || num === undefined) return "--";
  if (num === 0.0) return "₹0.0";
  return num.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  });
}

export function truncateText(text, maxLength) {
  if (text === null || text === undefined) return "---";
  if (text.length > maxLength) {
    return text.slice(0, maxLength - 3) + "...";
  }
  return text;
}
export function indianNumberFormat(num) {
  if (num === null || num === undefined || num === str) return "--";
  num = Number(num);
  if (num >= 1e7) {
    num = num / 1e7;
    return `${num.toFixed(2)} Cr`;
  } else if (num >= 1e5) {
    num = num / 1e5;
    return `${num.toFixed(1)} L`;
  } else if (num >= 1e3) {
    num = num / 1e3;
    return `${num.toFixed(2)} K`;
  }
  return num.toFixed(2).toString();
  // return num.toString();
}
export function formatString(str) {
  if (str === null) return "---";
  if (str === "cams_aa_finserv") return "CAMS AA Finserv";
  if (str === "nadl") return "NADL";
  return str
    .replace(/_/g, " ") // Replace underscores with spaces
    .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
}

export const baseColors = [
  "#f7a452",
  "#ed787d",
  "#66a9e4",
  "#26aba4",
  "#9d53f2",
  "#ff8c00",
  "#cd5c5c",
  "#64e8ed",
  "#00fa94",
  "#cae967",
  "#4682b4",
  "#8fbf8f",
  "#ba55d3",
  "#20b258",
  "#ff4500",
  "#32cd32",
  "#cc8e32",
  "#ff1493",
  "#ff69b4",
];

export const handleDownloadFile = (url) => {
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", ""); // 'download' attribute triggers download
  document.body.appendChild(link);
  link.click();
  link.remove();
};
